import 'messenger/build/js/messenger.js';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import {
  NgModule,
  ApplicationRef,
  LOCALE_ID
} from '@angular/core';
import {
  removeNgStyles,
  createNewHosts,
  createInputTransfer
} from '@angularclass/hmr';
import {
  RouterModule,
} from '@angular/router';
import { CurrencyPipe } from '@angular/common';
import { NgxImgModule } from 'ngx-img';
import { LocalStorageModule } from 'angular-2-local-storage';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CustomCommonModule } from './common/module';
import { ImageCropperModule } from 'ngx-image-cropper';

import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';

/*
 * Platform and Environment providers/directives/pipes
 */
import { ENV_PROVIDERS } from './environment';
import { ROUTES } from './app.routes';
// App is our top level component
import { App } from './app.component';
import { AppState, InternalStateType, AppCanLoad, AppHttpRequestInterceptor } from './app.service';

// common services used in several
import { AppConfig } from './app.config';
import { SharedService } from './common/service';
import { version } from 'process';
// import { ErrorComponent } from './error/error.component';


// Application wide providers
const APP_PROVIDERS = [
  AppState,
  AppConfig,
  AppCanLoad
];
interface StoreType {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
}

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [App],
  declarations: [
    App,
    // ErrorComponent,
  ],
  imports: [ // import Angular's modules
    BrowserModule,
    FormsModule,
    HttpModule,
    NgxImgModule,
    HttpClientModule,
    RouterModule.forRoot(ROUTES, { useHash: false /*, enableTracing: ENV === 'development'*/ }),
    LocalStorageModule.withConfig({
      prefix: 'app',
      storageType: 'localStorage',
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient]
      }
    }),
    CustomCommonModule,
  ],
  providers: [ // expose our Services and Providers into Angular's dependency injection
    ENV_PROVIDERS,
    APP_PROVIDERS,
    CurrencyPipe,
    { provide: Window, useValue: window },
    // {
    //   provide: LOCALE_ID,
    //   deps: [SharedService],      //some service handling global settings
    //   useFactory: (SharedService) => SharedService.language  //returns locale string
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpRequestInterceptor,
      multi: true,
    },
    /*{
     provide: LOCALE_ID,
     deps: [SettingsService],      //some service handling global settings
     useFactory: (settingsService) => settingsService.getLanguage()  //returns locale string
    }*/
  ],
})
export class AppModule {

  constructor(
    public appRef: ApplicationRef,
    public appState: AppState
  ) { }

  public hmrOnInit(store: StoreType) {
    if (!store || !store.state) {
      return;
    }
    console.log('HMR store', JSON.stringify(store, null, 2));
    /**
     * Set state
     */
    this.appState._state = store.state;
    /**
     * Set input values
     */
    if ('restoreInputValues' in store) {
      const restoreInputValues = store.restoreInputValues;
      setTimeout(restoreInputValues);
    }

    this.appRef.tick();
    delete store.state;
    delete store.restoreInputValues;
  }

  public hmrOnDestroy(store: StoreType) {
    const cmpLocation = this.appRef.components.map((cmp) => cmp.location.nativeElement);
    /**
     * Save state
     */
    const state = this.appState._state;
    store.state = state;
    /**
     * Recreate root elements
     */
    store.disposeOldHosts = createNewHosts(cmpLocation);
    /**
     * Save input values
     */
    store.restoreInputValues = createInputTransfer();
    /**
     * Remove styles
     */
    removeNgStyles();
  }

  public hmrAfterDestroy(store: StoreType) {
    /**
     * Display new elements
     */
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.module.ts